import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import Field from "../components/Field";
import FormMessage from "../components/FormMessage";
import { apiFetch } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await apiFetch("/api/auth/password-reset/request", {
        method: "POST",
        body: { email },
      });
      setSent(true);
    } catch {
      // We intentionally show the same success state either way so the
      // form can't be used to enumerate registered emails.
      setSent(true);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthShell
      eyebrow="Password"
      title="reset it."
      intro="Enter the email on your account and we'll send a reset link."
      footer={
        <>
          Remembered it?{" "}
          <Link to="/login" style={{ textDecoration: "underline" }}>
            Back to sign in
          </Link>
        </>
      }
    >
      {sent ? (
        <FormMessage tone="success">
          If an account exists for <strong>{email}</strong>, we just sent a
          reset link. The link expires in 30 minutes.
        </FormMessage>
      ) : (
        <form onSubmit={onSubmit} noValidate>
          <Field
            label="Email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.currentTarget.value)}
          />
          <button
            type="submit"
            className="btn btn--primary"
            disabled={submitting}
            style={{ width: "100%", marginTop: "0.5rem" }}
          >
            {submitting ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
